import { AskGenIcon } from '@verbit-ai/icons-library'

import { QuickActionButton } from 'src/components/QuickActionMenu/QuickActionButton'
import { useQuickActionMenu } from 'src/components/QuickActionMenu/QuickActionContext'
import { useFerretSearch } from 'src/contexts/FerretSearchWrapperProvider'
import { analyticsService } from 'src/services/AnalyticsService'

export const QuickActionFerretSearch = () => {
    const { ferretSearchRef } = useFerretSearch()
    const { selectedText } = useQuickActionMenu()

    const handleSearch = () => {
        ferretSearchRef?.current?.search(selectedText)
        analyticsService.track('Trigger search selected', { searchValue: selectedText })
    }

    return (
        <QuickActionButton
            data-appcues-ai-search="ferret-ai-search-button"
            label="Search"
            tooltip="Search selected text"
            icon={<AskGenIcon />}
            onClick={handleSearch}
        />
    )
}
